import React from 'react';
import { string } from 'prop-types';
import { Typography } from '@mui/material';

const DrawerTitle = ({ children }) => (
  <Typography
    component="div"
    sx={theme => ({
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSize: '28px',
      fontWeight: 'bold',
      letterSpacing: '-0.7px',
      fontStyle: 'normal',
      fontStretch: 'normal',
      color: theme.palette.primary.ultraDark,
    })}
  >
    {children}
  </Typography>
);
DrawerTitle.propTypes = {
  children: string.isRequired,
};

export default DrawerTitle;
